import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = ["currentPage"]

  connect() {
		this.currentPageTarget.scrollIntoView({ behavior: "instant", block: "nearest", inline: "center" })
  }
}
